'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { AdaptiveDialog } from '@/shared/ui/AdaptiveDialog';
import { Input } from '@/shared/ui/shadcn/input';
import { useReceiptEmailRequest } from '../lib/receipt-email';

/** Asks for the receipt e-mail before a T-Bank checkout (see receipt-email.ts). */
export function ReceiptEmailDialog() {
  const t = useTranslations('auth.signInMethods');
  const pending = useReceiptEmailRequest((s) => s.pending);
  const [email, setEmail] = useState('');

  if (!pending) return null;

  return (
    <AdaptiveDialog
      open
      onClose={() => pending(null)}
      title={t('email')}
      onSave={() => pending(email.trim())}
      saveEnabled={email.includes('@')}
      saveLabel={t('confirm')}
    >
      <Input
        type="email"
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('email')}
      />
    </AdaptiveDialog>
  );
}
